import { MEMBER_DASHBOARD_ROUTER } from "@Router/routerPath";
import { Dashboard } from "@Local/Dashboard";

const DashboardRouter = [
	{
		description: "儀表板",
		static: true,
		path: MEMBER_DASHBOARD_ROUTER,
		href: MEMBER_DASHBOARD_ROUTER,
		as: Dashboard,
	},
];

export default DashboardRouter;
